<template>
  <div>
    <i
      v-if="is_staff || is_superuser"
      class="mdi mdi-pencil"
      @click="$bvModal.show(personName + attendance_id)"
    ></i>
    <b-modal
      :id="personName + attendance_id"
      title="Επεξεργασία Χτυπήματος"
      centered
      hide-footer
    >
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">
              Επεξεργασία Χτυπήματος,
              {{ personFullName }}
              {{ parseTimestamp(attendanceTimestamp) }}
            </h4>

            <form
              class="needs-validation"
              @submit.prevent="attendanceModalEdit()"
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="validationCustom01"
                      >Ημερομηνία και Ωρα Χτυπήματος Κάρτας</label
                    >
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label class="mt-3">Ημερομηνία</label>
                        <b-form-datepicker
                          v-model="attendanceTimeToDate"
                          confirm
                          locale="el"
                          calendarWidth="300"
                          :start-weekday="1"
                          disabled
                        ></b-form-datepicker>
                      </div>
                      <div class="mb-3">
                        <label class="mt-3">Ώρα </label>
                        <date-picker
                          v-model="timestamp"
                          format="HH:mm"
                          value-type="format"
                          type="time"
                          placeholder="hh:mm"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">
                Ολοκλήρωση
              </button>
            </form>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { mapGetters } from "vuex";
import moment from "moment";
import session from "../../../../api/session";
import { eventCreate } from "../../../../eventspy.js";

export default {
  components: {
    DatePicker,
  },
  props: [
    "attendanceDate",
    "attendanceTimestamp",
    "attendanceID",
    "attendanceUserID",
    "personFullName",
  ],
  data() {
    return {
      timestamp: "",
      date: this.attendanceTimestamp,
      attendance_id: this.attendanceID,
      personName: this.personFullName,
    };
  },
  computed: {
    ...mapGetters("auth", ["userLoggedIn", "is_staff", "is_superuser"]),
    attendanceTimeToDate() {
      return moment(this.attendanceTimestamp).format("yyyy-MM-DD");
    },
    attendanceTimeValue() {
      return moment(this.attendanceTimestamp).format("HH:mm");
    },
  },
  methods: {
    async attendanceModalEdit() {
      const fullTimestamp = moment(
        this.attendanceTimeToDate + " " + this.timestamp
      ).format();
      await session
        .put(`api/attendances/${this.attendanceID}/attendance/`, {
          timestamp: fullTimestamp,
          user_id: this.attendanceUserID,
          punch: 0,
          status: 2,
          device: "ΚΑΤ' ΕΝΤΟΛΗ",
        })
        .then(() => {
          this.$toastr.Add({
            name: "UniqueToastName",
            title: `Ενημέρωση ${this.personFullName}`,
            msg: "Τα χτύπημα του χρήστη ανανεώθηκαν επιτυχώς!",
            style: { backgroundColor: "#4fd69c", width: "550px" },
            progressbar: false,
            timeout: 2000,
          });

          eventCreate(
            `Επεξεργασία - ημιτελεις παρουσίες  timestamp: ${fullTimestamp} person:${this.attendanceUserID}, `,
            2
          );
          this.$emit("AttendanceUpdate");
          this.$bvModal.hide(this.personName + this.attendance_id);
        })
        .catch((e) => {
          console.log(e.response.data);
        });
    },
    parseTimestamp(timestamp) {
      return moment(timestamp).format("HH:mm:ss");
    },
    parseTimestampToDate(timestamp) {
      return moment(timestamp).format("yyyy/MM/DD");
    },
  },
};
</script>

<style scoped>
.mdi-pencil {
  padding: 8px;
  color: rgb(224, 151, 15);
  transition: all 0.4s;
  margin-right: 5px;
}
.mdi-pencil:hover {
  color: rgb(224, 151, 15);
  cursor: pointer;
  font-size: 20px;
}
</style>
